import * as React from "react";

const Empty = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.4999 2.60002C4.00285 2.60002 3.5999 3.00297 3.5999 3.50002V12.7185L6.65508 10.1712C7.43401 9.52169 8.5658 9.52169 9.34473 10.1712L12.3999 12.7185V3.50002C12.3999 3.00297 11.997 2.60002 11.4999 2.60002H4.4999ZM2.3999 3.50002C2.3999 2.34023 3.3401 1.40002 4.4999 1.40002H11.4999C12.6597 1.40002 13.5999 2.34023 13.5999 3.50002V14C13.5999 14.2329 13.4652 14.4447 13.2543 14.5434C13.0435 14.6421 12.7945 14.61 12.6157 14.4609L8.57626 11.0928C8.24243 10.8145 7.75738 10.8145 7.42355 11.0928L3.38414 14.4609C3.20531 14.61 2.95635 14.6421 2.74548 14.5434C2.53461 14.4447 2.3999 14.2329 2.3999 14V3.50002Z"
    />
);
const Filled = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3999 3.50002C2.3999 2.34023 3.3401 1.40002 4.4999 1.40002H11.4999C12.6597 1.40002 13.5999 2.34023 13.5999 3.50002V14C13.5999 14.2329 13.4652 14.4447 13.2543 14.5434C13.0435 14.6421 12.7945 14.61 12.6157 14.4609L8.57626 11.0928C8.24243 10.8145 7.75738 10.8145 7.42355 11.0928L3.38414 14.4609C3.20531 14.61 2.95635 14.6421 2.74548 14.5434C2.53461 14.4447 2.3999 14.2329 2.3999 14V3.50002Z"
    />
);
export const Bookmark = {
    Empty,
    Filled,
};
